import type { MRT_ColumnDef } from "mantine-react-table-open";
import type {
  SiteLabel,
  SiteOverviewSite,
  SiteStatusSite
} from "../../site-status-types";

function getSiteLabelsColumn(): MRT_ColumnDef<
  SiteOverviewSite | SiteStatusSite
> {
  return {
    header: "Label",
    accessorKey: "siteLabels",
    size: 200,
    enableGlobalFilter: false,
    Cell: ({ cell }) =>
      cell
        .getValue<Array<SiteLabel>>()
        .map((siteLabel) => siteLabel.name)
        .join(", ") || "-",
    sortingFn: (rowA, rowB) => {
      const aLabels =
        rowA
          .getValue<Array<SiteLabel>>("siteLabels")
          .map((siteLabel) => siteLabel.name)
          .join(", ") || "";
      const bLabels =
        rowB
          .getValue<Array<SiteLabel>>("siteLabels")
          .map((siteLabel) => siteLabel.name)
          .join(", ") || "";
      return aLabels.localeCompare(bLabels);
    },
    filterFn: (row, _columnId, filterValue) => {
      return row
        .getValue<Array<SiteLabel>>("siteLabels")
        .some((label) => label.name.includes(filterValue));
    }
  };
}

export { getSiteLabelsColumn };
